import { deviceBreakpoints, deviceTypes } from './constants';

export function getDeviceType(deviceWidth) {
  if (deviceWidth > deviceBreakpoints.desktopMedium) {
    return deviceTypes.desktopLarge;
  }
  if (
    deviceWidth > deviceBreakpoints.desktopSmall &&
    deviceWidth <= deviceBreakpoints.desktopMedium
  ) {
    return deviceTypes.desktopMedium;
  }
  if (
    deviceWidth > deviceBreakpoints.laptop &&
    deviceWidth <= deviceBreakpoints.desktopSmall
  ) {
    return deviceTypes.desktopSmall;
  }
  if (
    deviceWidth > deviceBreakpoints.mobile &&
    deviceWidth <= deviceBreakpoints.laptop
  ) {
    return deviceTypes.laptop;
  }

  return deviceTypes.mobile;
}
